/**
 * Custom React hook that keeps the OneTrust consent SDK hidden while a Surfly
 * co-browse session is visible, so it cannot overlap the Surfly PIN modal.
 */
import { useEffect } from 'react'
import syncOneTrustWithSurfly from 'utils/syncOneTrustWithSurfly'

export function useSurflyOneTrustVisibility(): void {
  useEffect(() => syncOneTrustWithSurfly(), [])
}
